import Vue from 'vue'
import router from '@/router'
import { ACCESS_TOKEN, USER_ROLE } from "@/store/mutation-types";
import HomeLayout from './layouts/HomeLayout'
import { BlankLayout } from '@/components/layouts'

const whiteList = ['/user/login', '/home', '/article', '/contest'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  console.log(Vue.ls.get(ACCESS_TOKEN));
  console.log(to);
  if (Vue.ls.get(ACCESS_TOKEN)) {
      next()
  } else {
    if (whiteList.indexOf(to.path) == -1) {
      next()
      // next({ path: '/user/login', query: { redirect: to.fullPath } })
    }else{
      next()
    }
  }
})

/**
 * 基础路由
 * @type { *[] }
 */
const RouterMap = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "xinai" */ './views/Home')
  },
  {
    path: '/user',
    component: HomeLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "xinai" */ './views/Login')
      },
      {
        path: 'register',
        name: 'register',
        component:()=>import(/* webpackChunkName: "xinai" */ './views/Register')
      },
      {
        path: 'find',
        name: 'find',
        component:()=>import(/* webpackChunkName: "xinai" */ './views/Find')
      }
    ]
  },
  {
    path: '/production',
    name: 'production',
    redirect: '/production/index',
    component: HomeLayout,
    children: [
      {
        path: 'index',
        name: 'productIndex',
        component: () => import(/* webpackChunkName: "xinai" */ './views/ProductList')
      },
      {
        path: 'detail',
        name: 'productDetail',
        component: () => import(/* webpackChunkName: "xinai" */ './views/ProductDetail')
      },
    ]
  },
  {
    path: '/course',
    name: 'course',
    redirect: '/course/index',
    component: HomeLayout,
    children: [
      {
        path: 'index',
        name: 'courseIndex',
        component: () => import(/* webpackChunkName: "xinai" */ './views/CourseList')
      },
      {
        path: 'detail',
        name: 'courseDetail',
        component: () => import(/* webpackChunkName: "xinai" */ './views/CourseDetail')
      },
    ]
  },
  {
    path: '/contest',
    name: 'contest',
    redirect: '/contest/index',
    component: HomeLayout,
    children: [
      {
        path: 'index',
        name: 'contestIndex',
        component: () => import(/* webpackChunkName: "xinai" */ './views/ContestList')
      },
      {
        path: 'detail',
        name: 'contestDetail',
        component: () => import(/* webpackChunkName: "xinai" */ './views/ContestDetail')
      },
    ]
  },
  {
    path: '/paper',
    name: 'paper',
    redirect: '/paper/index',
    component: HomeLayout,
    children: [
      {
        path: 'index',
        name: 'paperIndex',
        component: () => import(/* webpackChunkName: "xinai" */ './views/PaperList')
      },
      // {
      //   path: 'detail',
      //   name: 'paperDetail',
      //   component: () => import(/* webpackChunkName: "xinai" */ './views/PaperDetail')
      // },
    ]
  },
  {
    // path: '/news',
    // component: HomeLayout,
    // redirect: '/news/index',
    // children: [
      // {
        path: '/news',
        name: 'newsIndex',
        component: ()=> import(/* webpackChunkName: "xinai" */ './views/ArticleList')
      // },
    // ]
  },
  {
    path: '/examine',
    component:()=>import(/* webpackChunkName: "xinai" */ '@/components/exam/Examine')
  }
]
export default RouterMap